import { useQuery } from "@tanstack/react-query"

import { LibraryResponses } from "@tfg/types/endpoints/library"
import {
  SupplierGetQueryValidationType,
  supplierMonitoringFiltersValidationType,
} from "@tfg/types/schemas/organization/schemas"
import { fetchDataOptionsParam } from "@tfg/types/schemas/products"

import { httpClient } from "~/backend/axios.ts"

export const useListSubSuppliersQuery = ({
  fetchDataOptions,
  searchSupplier,
  filters,
  orderBy,
}: Omit<SupplierGetQueryValidationType, "filters"> &
  fetchDataOptionsParam & {
    filters: supplierMonitoringFiltersValidationType
  }) => {
  return useQuery<LibraryResponses.SuppliersResponse>(
    ["suppliers", fetchDataOptions, searchSupplier, filters, orderBy],
    async () => {
      const skip = fetchDataOptions.pageIndex * fetchDataOptions.pageSize
      const take = fetchDataOptions.pageSize
      const res = await httpClient.get<LibraryResponses.SuppliersResponse>(
        "suppliers/sub-suppliers",
        {
          params: {
            skip,
            take,
            searchSupplier,
            filters: JSON.stringify(filters),
            orderBy: JSON.stringify(orderBy),
          },
        }
      )
      return res.data
    }
  )
}
